
export const TALOS_ID = 'CUS-c8f0dd3ff1fb49979a15cc7c2e973611ab48f3b43d58fce98535e16d68b2d8ad';